export const CommFunc = {
    // 判断是否为空
    isEmpty(val) {
        if (typeof val == 'object') {
            return JSON.stringify(val) === '{}' || val == null;
        } else {
            return (typeof val === 'undefined' || val === null || val === "");
        }
    },
    timeFormatter(time){
        let now = new Date(time);
        var year = now.getFullYear(); //得到年份
		var month = now.getMonth();//得到月份
		var date = now.getDate();//得到日期
		month = month + 1;
		if (month < 10) month = "0" + month;
		if (date < 10) date = "0" + date;
        return year + "-" + month + "-" + date
    }   
}


// WEBPACK FOOTER //
// ./src/utils/commonFunc.js